module.exports = __webpack_public_path__ + "static/img/logo_mingshuo.cbc601b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_mingshuo.png
// module id = cMyx
// module chunks = 15